<template>
  <div class="abort-wrap deliveryAbort__content">
    <g-back :history="history"></g-back>
    <el-row>
      <el-col :span="12">
        <span v-text="$t('appDelivery.appName') + '：'"></span><span v-text="abortInfo.appName"></span>
      </el-col>
      <el-col :span="12">
        <span v-text="$t('appDelivery.deployStrategy') + '：'"></span><span v-text="strategyText"></span>
      </el-col>
    </el-row>
    <el-row class="mt-base">
      <el-col :span="12">
        <span v-text="$t('appDelivery.version') + '：'"></span><span v-text="abortInfo.version"></span>
      </el-col>
      <el-col :span="12">
        <span v-text="$t('appDelivery.installWay') + '：'"></span><span v-text="select_install[abortInfo.upgradeType]"></span>
      </el-col>
    </el-row>
    <div class="mt-base">
      <span v-text="$t('appDelivery.logDetail') + '：'"></span>
      <span v-text="abortInfo.exceptions" class="log-exceptions"></span>
    </div>
  </div>
</template>

<script>
  import dic from '@/components/mixins/dic'
  import appDeliveryBiz from '@/logic/continuousDelivery/appDeliveryBiz'
  export default {
    mixins: [dic],
    data () {
      return {
        history: [],
        select_install: {},
        abortInfo: {},
        strategyText: '',
        tactics: {
          beforeUpgrade: false,
          afterUpgrade: false,
          afterInstall: false,
          afterRelease: false
        }
      }
    },
    methods: {
      setHistory () {
        this.history = []
        this.history.push({
          name: this.$t('appDelivery.releaseOverview'),
          path: `/home/appDelivery/releaseOverview?id=${this.$route.query.id}`
        })
        this.history.push({ name: this.$t('appDelivery.anomalyDetection') })
      },
      async waitInstallWay () {
        await this.dGetDictionaryByCode('appPackageType')
        this.select_install = { ...this.dDictionary.appPackageType }
      },
      getAbort () {
        appDeliveryBiz.deliveryAbort({ id: this.$route.query.id }).then((data) => {
          this.abortInfo = data
          for (let i in this.tactics) {
            this.tactics[i] = false
          }
          if (data.tactics && Object.keys(data.tactics).length > 0) this.tactics = data.tactics
          this.setStrategyText()
        })
      },
      setStrategyText () {
        let beforeUpgradeText = this.tactics.beforeUpgrade ? this.$t('appDelivery.beforeUpgrade') : ''
        let afterUpgradeText = this.tactics.afterUpgrade ? this.$t('appDelivery.afterUpgrade') : ''
        let afterInstallText = this.tactics.afterInstall ? this.$t('appDelivery.afterInstall') : ''
        let afterReleaseText = this.tactics.afterRelease ? this.$t('appDelivery.afterRelease') : ''
        let text = (this.tactics.beforeUpgrade || this.tactics.afterUpgrade || this.tactics.afterInstall || this.tactics.afterRelease)
          ? [beforeUpgradeText, afterUpgradeText, afterInstallText, afterReleaseText].filter((item) => {
            return item !== ''
          }).join('、') : this.$t('common.none')
        this.strategyText = text
      }
    },
    components: {},
    watch: {
      $route (to, from) {
        if (to.name === 'deliveryAbort' && from.name === 'releaseOverview') {
          this.getAbort()
        }
      }
    },
    mounted () {
      this.setHistory()
      this.waitInstallWay()
      this.getAbort()
    }
  }
</script>

<style scoped>
  .abort-wrap {
    width: 840px;
    padding: 0 20px;
    font-size: 14px;
  }
  .log-exceptions {
    white-space: pre-wrap;
    vertical-align: text-top;
    display: inline-block;
    width: 450px;
  }
</style>